import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, AlertTriangle } from "lucide-react";
import { RESOURCES } from "../lib/resources";
import usePageMeta from "../lib/usePageMeta";

export default function ResourcesPage() {
  usePageMeta({
    title: "Resource Library | CCCHAPS Care Portal",
    description: "Honest, practical guides for hard seasons — resources for employees of organizations enrolled with California Corporate Chaplains.",
  });
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-testid="resources-page">
      <div className="max-w-2xl mb-10">
        <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-medium mb-3">Resource library</p>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight text-slate-900">
          Honest, practical guides for hard seasons.
        </h1>
        <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
          Short reads written for working adults — no clinical jargon, no toxic positivity.
        </p>
      </div>

      <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 mb-10 flex gap-3" data-testid="resources-crisis-disclaimer">
        <AlertTriangle className="w-5 h-5 text-amber-700 shrink-0 mt-0.5" />
        <p className="text-sm text-amber-900 leading-relaxed">
          This portal is not for medical emergencies, mental health emergencies, or immediate danger.
          Call <span className="font-semibold">911</span> or local emergency services if you are in immediate danger.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {RESOURCES.map((r) => (
          <Link
            to={`/care-portal/resources/${r.slug}`}
            key={r.slug}
            data-testid={`resource-card-${r.slug}`}
            className="group bg-white border border-slate-200 rounded-xl p-6 md:p-7 hover:border-[#4A6FA5] hover:shadow-md transition-all duration-200 flex flex-col"
          >
            <div className="flex items-center justify-between">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-[#F0F4F8] text-[#4A6FA5]">
                <BookOpen className="w-5 h-5" strokeWidth={1.75} />
              </span>
              <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-[#4A6FA5] group-hover:translate-x-0.5 transition-all" />
            </div>
            <h3 className="mt-5 font-heading text-xl font-medium text-slate-900">{r.title}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{r.summary}</p>
            <span className="mt-5 text-xs uppercase tracking-[0.18em] text-[#4A6FA5] font-medium">Read guide</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
